'use client';

import { Provider, createStore } from 'jotai';
import { PropsWithChildren, useState } from 'react';

import { JotaiStoreContext } from '@flipster/utils/bunja-jotai';

export const JotaiProvider = ({ children }: PropsWithChildren) => {
  const [store] = useState(createStore);
  return (
    <JotaiStoreContext value={store}>
      <Provider store={store}>{children}</Provider>
    </JotaiStoreContext>
  );
};
